import { render, staticRenderFns } from "./ChartLoader.vue?vue&type=template&id=2d6d14a0&"
import script from "./ChartLoader.vue?vue&type=script&lang=js&"
export * from "./ChartLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6d14a0')) {
      api.createRecord('2d6d14a0', component.options)
    } else {
      api.reload('2d6d14a0', component.options)
    }
    module.hot.accept("./ChartLoader.vue?vue&type=template&id=2d6d14a0&", function () {
      api.rerender('2d6d14a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/purchase-activity/ChartLoader.vue"
export default component.exports